'use strict';
checkList.classy.controller({
    name: 'ChildcareExpensesReported',
    inject: ['$scope', 'RestService', 'ApplicationService', 'PutService',
        'AddedAllowanceModelFactory'],
    init: function () 
    {
        this.familyID = this.ApplicationService.getFamilyData().data[0].familyID;
        this.$.setAnswer(83);
        this.AddedAllowanceModelService = new this.AddedAllowanceModelFactory(this.familyID);
    },
    childcareExpensesComplete: function () 
    {
        var caseNo = 'case83';
        var queue = [];
        var amount;
        var self = this;

        // get id of addedAllowance (if exists)
        var addedAllowance = this.AddedAllowanceModelService.getById(this.$.answer.allowanceID);

        if (this.$.answer.choice != 0)
        {

            if (this.$.answer.choice == 1)
                amount = parseInt(this.ApplicationService.getFamilyData().edit_sums.Exp_Childcare_Val);
            else if (this.$.answer.choice == 2)
                amount = parseInt(this.$.answer.amount);

            // if addedAllowance doesn't exist
            if (typeof this.$.answer.allowanceID === 'undefined' || !addedAllowance )
            {
                // create a new allowance
                var index = this.AddedAllowanceModelService.new();
                addedAllowance = this.AddedAllowanceModelService.data[index];
                addedAllowance.text = 'Child Care';
                addedAllowance.amount = amount;

                // post allowance, alert info, and update data
                this.AddedAllowanceModelService.post(this.familyID, addedAllowance).then(function(data){
                    self.$.answer.allowanceID = data.data.id;
                    addedAllowance.recordID = data.data.id;
                    self.$.alertPut(queue, caseNo, 0, self.$.answer);
                    self.AddedAllowanceModelService.updateData();
                });
            }
            else // if allowance does exist, update amount, alert info 
            {
                addedAllowance.amount = amount;
                this.AddedAllowanceModelService.put(this.familyID, addedAllowance).then(function(data)
                {
                    self.$.alertPut(queue, caseNo, 0, self.$.answer);
                });
            }
        }
        else
        {
            // remove previous added allowance and put alert info
            if (this.$.answer.allowanceID) {
                this.AddedAllowanceModelService.purge(null, {recordID: this.$.answer.allowanceID});
                delete this.$.answer.allowanceID;
            }
            this.$.alertPut(queue, caseNo, 0, this.$.answer);
        }
    }
});
